import { render, staticRenderFns } from "./SupplierFilesTab.vue?vue&type=template&id=ce5beda2&scoped=true&"
import script from "./SupplierFilesTab.vue?vue&type=script&lang=js&"
export * from "./SupplierFilesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5beda2",
  null
  
)

export default component.exports